import api from "api/axios";

export type LLMProvider = "openai" | "deepseek";

export interface LLMProviderSetting {
  feature: string;
  label: string;
  provider: LLMProvider;
}

export async function fetchLLMProviderSettings(): Promise<LLMProviderSetting[]> {
  const res = await api.get("/admin/settings/llm-providers");
  return res.data;
}

export async function updateLLMProviderSetting(feature: string, provider: LLMProvider): Promise<void> {
  await api.patch(`/admin/settings/llm-providers/${feature}`, { provider });
}

export type UpworkConnectionStatus = "connected" | "disconnected" | "error";

export interface UpworkConnection {
  status: UpworkConnectionStatus;
  connected: boolean;
  upwork_user_id: string | null;
  granted_scopes: string | null;
  last_connected_at: string | null;
  last_refreshed_at: string | null;
  token_expires_at: string | null;
  last_error: string | null;
  connected_by_admin_email: string | null;
}

export async function fetchUpworkConnection(): Promise<UpworkConnection> {
  const res = await api.get("/admin/upwork/connection");
  return res.data;
}

export async function startUpworkConnect(): Promise<{ authorization_url: string }> {
  const res = await api.post("/admin/upwork/connect");
  return res.data;
}

export async function disconnectUpwork(): Promise<UpworkConnection> {
  const res = await api.post("/admin/upwork/disconnect");
  return res.data;
}
